<script>
import CpButton from '../button';
import CpGrid from '../grid';
import CpGridItem from '../grid-item';
import CpTextInput from '../inputs/text';

export default {
    name: 'CpSignInfo',
    components: {
        CpButton,
        CpGrid,
        CpGridItem,
        CpTextInput,
    },
    props: {
        icon: '',
        title: '',
        step1Title: '',
        step1Description: '',
        step2Title: '',
        step2Description: '',
        step3Title: '',
        step3Description: '',
    },
};
</script>

<template>
    <div class="infoContainer">
        <div v-if="icon" class="iconContainer"><i :class="['fal', icon, 'fa-4x']"></i></div>
        <h2 v-if="title" class="centerAlign H2 neutral5-color">{{ title }}</h2>
        <div class="stepContainer">
            <img width="38" src="https://res.cloudinary.com/crowdpac/image/upload/f_auto,q_auto/v1/assets/signin-check">
            <span class="stepTextContainer">
                <p class="subheadline1 neutral6-color mb0">1. {{step1Title}}</p>
                <p class="body neutral6-color">{{step1Description}}</p>
            </span>
        </div>
        <div class="stepContainer opacity0-4">
            <img width="38" src="https://res.cloudinary.com/crowdpac/image/upload/f_auto,q_auto/v1/assets/signin-check">
            <span class="stepTextContainer">
                <p class="subheadline1 neutral6-color mb0">2. {{step2Title}}</p>
                <p class="body neutral6-color">{{step2Description}}</p>
            </span>
        </div>
        <div class="stepContainer opacity0-4">
            <img width="38" src="https://res.cloudinary.com/crowdpac/image/upload/f_auto,q_auto/v1/assets/signin-check">
            <span class="stepTextContainer">
                <p class="subheadline1 neutral6-color mb0">3. {{step3Title}}</p>
                <p class="body neutral6-color">{{step3Description}}</p>
            </span>
        </div>
    </div>
</template>

<style scoped>
.iconContainer {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    color: #ED572F;
}

.infoContainer {
    padding-left: 200px;
}

.centerAlign {
    text-align: center;
}

.social-buttons-container {
    padding-top: 20px;
}

.forgotContainer {
    display: flex;
    justify-content: flex-end;
}

.stepContainer {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
}

.stepTextContainer {
    padding-left: 16px;
}

.mb0 {
    margin-bottom: 0;
}

.opacity0-4 {
    opacity: 0.4;
}

@media only screen and (max-width: 1200px) {
    .infoContainer {
        padding-left: 100px;
    }
}

@media only screen and (max-width: 1000px) {
    .infoContainer {
        padding-left: 0px;
    }
}
</style>